import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as configActions } from '../../store/ducks/config-section';

import { View, ScrollView, TouchableOpacity } from 'react-native';
import Text from '../../react-component/textComponent';
import styles from './styles';
import Colors from '../../config/Colors';
import {
    SECTIONS,
    TIPO_ENTREGA_RETIRADA
} from '../../constants/configuracao-horarios';

const OptionsList = ({ section, selectSection, selectTab, user }) => {
    const renderOption = ({ title, subtile, selected }) => {
        return (
            <TouchableOpacity
                onPress={() => {
                    selectSection({ selectedSection: title });
                    selectTab({
                        idTipoEntregaRetirada: TIPO_ENTREGA_RETIRADA.RETIRADA
                    });
                }}
                style={[
                    styles.itemList,
                    selected && { backgroundColor: Colors.lightBlue }
                ]}
            >
                <View style={styles.lineContent}>
                    <Text style={styles.itemTitle} $bold>
                        {title}
                    </Text>
                </View>

                <View style={styles.lineContent}>
                    <Text style={styles.itemSubtitle}>{subtile}</Text>
                </View>
            </TouchableOpacity>
        );
    };

    return (
        <View>
            <ScrollView>
                <Fragment>
                    {renderOption({
                        title: SECTIONS.CONFIGURAR_PEDIDOS,
                        subtile: 'Tempo de preparo, pedido mínimo…',
                        selected:
                            section.selectedSection ===
                            SECTIONS.CONFIGURAR_PEDIDOS
                    })}

                    {renderOption({
                        title: SECTIONS.HORARIO_FUNCIONAMENTO,
                        subtile: 'Funcionamento durante a semana',
                        selected:
                            section.selectedSection ===
                            SECTIONS.HORARIO_FUNCIONAMENTO
                    })}

                    {renderOption({
                        title: SECTIONS.FRETES,
                        subtile: 'Defina os valores para entregas',
                        selected: section.selectedSection === SECTIONS.FRETES
                    })}

                    {renderOption({
                        title: SECTIONS.USUARIOS,
                        subtile: 'Gerencie os usuários com acesso ao app',
                        selected: section.selectedSection === SECTIONS.USUARIOS
                    })}

                    {renderOption({
                        title: SECTIONS.FAIXA_CEP,
                        subtile: 'Faixas CEPs',
                        selected: section.selectedSection === SECTIONS.FAIXA_CEP
                    })}
                </Fragment>
            </ScrollView>
        </View>
    );
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...configActions
        },
        dispatch
    );

const mapStateToProps = ({ section, user }) => {
    return {
        section,
        user
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionsList);
